export default {
	title: 'Sensor Type Management',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete {count} selected record(s)?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select the record to delete',
		operateSuccess: 'Operation successful',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty'
	},
	form: {
		name: 'Type Name',
		axisCount: 'Axis Count',
		upMode: 'Upstream Mode',
		placeholder: {
			name: 'Please enter type name',
			axisCount: 'Please select axis count',
			upMode: 'Please select upstream mode'
		}
	},
	table: {
		id: 'ID',
		orgId: 'Organization',
		name: 'Type Name',
		icon: 'Icon',
		axisCount: 'Axis Count',
		upMode: 'Upstream Mode',
                sysEig: 'Feature Values',
		sysWave: 'Waveform'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	widgetForm: {
		name: 'Type Name',
		orgId: 'Organization',
		icon: 'Icon',
		upMode: 'Upstream Mode',
                characters: 'Feature Value Function Code',
		accelerate: 'Time Domain Function Code',
                sysEig: 'Feature Values',
		sysWave: 'Waveform Type',
		toolTypeId: 'Diagnostic Tool Type',
		axisCount: 'Axis Count',
		gridLayout: 'Grid Layout',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			name: 'Please select type name',
			orgId: 'Please select organization',
			icon: 'Please select icon',
			upMode: 'Please select upstream mode',
                        characters: 'Please enter feature value function code',
			accelerate: 'Please enter time domain function code',
			toolTypeId: 'Please select diagnostic tool type',
			axisCount: 'Please select axis count'
		}
	}
}
